import React, {FC, useState, useEffect} from "react"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage, getMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {updateOAuthSettings} from "@irati/sso/services/sso"
import authentication from "@irati/auth"
import {OAuthProvider} from "@irati/types"
import {getErrorMessage, getErrorValues} from "@irati/utils/lang/formatError"
import ErrorText from "@irati/ui/src/ErrorText"
import GenericModal from "@irati/ui/src/GenericModal"

interface Props extends InjectIntl  {
  show: boolean,
  onClose: () => void,
  onDelete: () => void
}

const DeleteSSOModal: FC<Props> = ({show, onClose, onDelete, formatMessage}) => {
  const [showDelete, setDelete] = useState<boolean>(show)
  const [showConfirmation, setConfirmation] = useState<boolean>(false)
  const [error, setError] = useState<string>()

  const handleDelete = () => {
    setError("")
    updateOAuthSettings(authentication.business().uuid, OAuthProvider.Unknown).then(() => {
      setDelete(false)
      setConfirmation(true)
    }).catch((err) => {
      const message = getMessage(formatMessage, getErrorMessage(err), getErrorValues(err))
      setError(message)
    })
  }

  const handleClose = () => {
    setDelete(false)
    onClose()
  }

  const handleConfirmClose = () => {
    setConfirmation(false)
    onDelete()
  }

  useEffect(() => {
    setDelete(show)
  }, [show])

  return (<>
    <GenericModal hideActions show={showDelete} onHide={handleClose} onExited={handleClose}>
      <H3 marginBottom={1}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.modal.title" />
      </H3>
      <Body marginBottom={3}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.modal.subTitle" />
      </Body>
      <Flex>
        <Button onClick={handleDelete} marginRight={1}>
          <FormattedMessage id="admin.components.integration.sso.editSSO.modal.btn.yes" />
        </Button>
        <Button primary onClick={handleClose}>
          <FormattedMessage id="admin.components.integration.sso.editSSO.modal.btn.no" />
        </Button>
      </Flex>
      {error && (
        <ErrorText>{error}</ErrorText>
      )}
    </GenericModal>
    <GenericModal hideActions show={showConfirmation} onHide={handleConfirmClose} onExited={handleConfirmClose}>
      <H3 marginBottom={3}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.modal.confirmation.title" />
      </H3>
      <Button primary onClick={handleConfirmClose}>
        <FormattedMessage id="admin.components.integration.sso.editSSO.modal.confirmation.btn" />
      </Button>
    </GenericModal>
  </>)
}

export default injectIntl(DeleteSSOModal)
